import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { FaBars } from "react-icons/fa6";
import { dark } from "../styles/Theme.styled";
//react router dom
import { NavLink, useLocation } from "react-router-dom";

//images
import portfolioDark from "../images/portfolio-dark.webp";
import portfolioLight from "../images/portfolio-transparent.webp";

const Nav = ({ setSidebarIsOpen, setDocNavIsOpen, docNavIsOpen, theme }) => {
  const isLocationHome = useLocation().pathname === "/";
  const docNavButton = useRef();
  const isLocationNotes = useLocation().pathname === "/course-notes";

  useEffect(() => {
    const checkBox = document.querySelector(".menu");
    checkBox.checked = docNavIsOpen;
  }, [docNavIsOpen]);

  useEffect(() => {
    const handler = (e) => {
      if (!docNavButton.current.contains(e.target)) {
        if (e.target.classList.contains("doc-link")) {
          return;
        }
        setDocNavIsOpen(false);
      }
    };
    document.addEventListener("pointerdown", handler);
    return () => {
      document.removeEventListener("pointerdown", handler);
    };
  });

  return (
    <Wrapper className="navbar">
      <div className="nav-center">
        <div
          ref={docNavButton}
          className={
            isLocationNotes
              ? "menu-button-container"
              : "menu-button-container hide"
          }
        >
          <input
            id="doc-nav-menu"
            onClick={() => {
              setDocNavIsOpen(!docNavIsOpen);
            }}
            type="checkbox"
            role="button"
            aria-label="Display the menu"
            className="menu"
          />
        </div>
        <div>
          <ul className="nav-links">
            <li className="nav-list-item">
              <NavLink
                className={({ isActive }) =>
                  isLocationHome && isActive
                    ? "nav-link active light-nav-link"
                    : isLocationHome && !isActive
                    ? "nav-link light-nav-link"
                    : !isLocationHome && isActive
                    ? "dark-nav-link active nav-link"
                    : "dark-nav-link nav-link"
                }
                to="/"
              >
                Home
              </NavLink>
            </li>
            <li className="nav-list-item">
              <NavLink
                className={({ isActive }) =>
                  isLocationHome && isActive
                    ? "nav-link active light-nav-link"
                    : isLocationHome && !isActive
                    ? "nav-link light-nav-link"
                    : !isLocationHome && isActive
                    ? "dark-nav-link active nav-link"
                    : "dark-nav-link nav-link"
                }
                to="projects"
              >
                Projects
              </NavLink>
            </li>

            <li className="nav-list-item">
              <NavLink
                className={({ isActive }) =>
                  isLocationHome && isActive
                    ? "nav-link active light-nav-link"
                    : isLocationHome && !isActive
                    ? "nav-link light-nav-link"
                    : !isLocationHome && isActive
                    ? "dark-nav-link active nav-link"
                    : "dark-nav-link nav-link"
                }
                to="contact"
              >
                Contact
              </NavLink>
            </li>
            <li className="nav-list-item">
              <NavLink
                className={({ isActive }) =>
                  isLocationHome && isActive
                    ? "nav-link active light-nav-link"
                    : isLocationHome && !isActive
                    ? "nav-link light-nav-link"
                    : !isLocationHome && isActive
                    ? "dark-nav-link active nav-link"
                    : "dark-nav-link nav-link"
                }
                to="course-notes"
              >
                Course Notes
              </NavLink>
            </li>
          </ul>
        </div>
        <img
          className="nav-logo"
          src={
            isLocationHome || theme === dark
              ? portfolioLight
              : !isLocationHome && theme !== dark
              ? portfolioDark
              : portfolioLight
          }
          alt="dark portfolio"
        />
        <button
          type="button"
          aria-label="mobile navigation menu toggle button"
          onClick={() => setSidebarIsOpen(true)}
          className="nav-toggle"
        >
          <FaBars />
        </button>
      </div>
    </Wrapper>
  );
};

export default Nav;

const Wrapper = styled.nav`
  .menu-button-container {
    display: grid;
    transition: 0.3s all linear;
  }
  .menu {
    /* control the size */
    --s: 1.9rem;
    /* the color */
    /* --c: ${({ theme }) => theme.colors.docMenuColor}; */
    z-index: 2;
    height: var(--s);
    aspect-ratio: 1;
    border: none;
    padding: 0;
    border-inline: calc(var(--s) / 2) solid #0000;
    box-sizing: content-box;
    --_g1: linear-gradient(var(--c) 20%, #0000 0 80%, var(--c) 0) no-repeat
      content-box border-box;
    --_g2: radial-gradient(
        circle closest-side at 50% 12.5%,
        var(--c) 95%,
        #0000
      )
      repeat-y content-box border-box;
    background: var(--_g2) left var(--_p, 0px) top,
      var(--_g1) left calc(var(--s) / 10 + var(--_p, 0px)) top,
      var(--_g2) right var(--_p, 0px) top,
      var(--_g1) right calc(var(--s) / 10 + var(--_p, 0px)) top;
    background-size: 20% 80%, 40% 100%;
    position: relative;
    clip-path: inset(0 25%);
    -webkit-mask: linear-gradient(90deg, #0000, #000 25% 75%, #0000);
    mask: linear-gradient(90deg, #0000, #000 25% 75%, #0000);
    cursor: pointer;
    transition: background-color 0.3s, 0.3s var(--_s, 0.3s),
      clip-path 0s var(--_s, 0.6s);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .menu:before,
  .menu:after {
    content: "";
    position: absolute;
    border-radius: var(--s);
    inset: 40% 0;
    background: var(--c);
    transition: background-color 0.3s,
      transform 0.3s calc(0.3s - var(--_s, 0.3s));
  }

  .menu:checked {
    clip-path: inset(0);
    --_p: calc(-1 * var(--s));
    --_s: 0s;
  }

  .menu:checked:before {
    transform: rotate(45deg);
  }

  .menu:checked:after {
    transform: rotate(-45deg);
  }

  .menu:focus-visible {
    clip-path: none;
    -webkit-mask: none;
    mask: none;
    border: none;
    outline: 2px solid var(--c);
    outline-offset: 5px;
  }
  .hide {
    transform: rotateX(90deg);
  }
  .nav-logo {
    width: 187px;
    height: 37px;
    margin: 0 auto;
    max-width: 100%;
    max-height: auto;
  }
`;
